// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7794b09e","732":"891596b7","977":"b486e7c1"}[chunkId] + ".chunk.js";
};